module.exports = __webpack_public_path__ + "img/encabezado-form.8201af50.gif";